import { render, staticRenderFns } from "./CreateTeamModal.vue?vue&type=template&id=5b0d5764&scoped=true&"
import script from "./CreateTeamModal.vue?vue&type=script&lang=js&"
export * from "./CreateTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeamModal.vue?vue&type=style&index=0&id=5b0d5764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d5764",
  null
  
)

export default component.exports